import { useCallback } from 'react';
import { useLanguage } from '../context/LanguageContext';

const messages = {
  fr: {
    langToggle: 'EN',
    navOverview: "Vue d'ensemble",
    navUsers: 'Utilisateurs',
    navReports: 'Signalements',
    navSettings: 'Paramètres',
    toastLoadSettingsError: 'Erreur chargement paramètres',
    toastSettingsSaved: 'Paramètres enregistrés',
    toastSaveError: 'Erreur enregistrement',
    toastLoadDashboardError: 'Erreur chargement CrushShy',
    toastLoadUsersError: 'Erreur chargement utilisateurs',
    toastLoadReportsError: 'Erreur chargement signalements',
    toastUserCreated: 'Utilisateur créé',
    toastUserUpdated: 'Utilisateur mis à jour',
    toastUserDeleted: 'Utilisateur supprimé',
    toastDeleteError: 'Erreur suppression',
    toastReportUpdated: 'Signalement mis à jour',
    toastError: 'Erreur',
    settingsTitle: 'Paramètres',
    settingsSubtitle: "Configuration globale de l'application CrushShy",
    settingsMobileApp: 'App mobile',
    settingsDemoUsers: 'Utilisateurs démo (carte & interactions)',
    settingsDemoUsersHint:
      'OFF = masqués pour tous les clients (actuels et futurs). Défaut : ON.',
    settingsAvailability: 'Disponibilité',
    settingsMaintenance: 'Mode maintenance',
    settingsMaintenanceHint: "Bloque l'accès à l'app pour tous les utilisateurs",
    settingsMaintenanceMessage: 'Message maintenance',
    settingsRules: 'Règles & limites',
    settingsMinAge: 'Âge minimum',
    settingsMaxDistance: 'Distance max par défaut (m)',
    settingsAutoSuspend: 'Suspension auto après N signalements',
    settingsMinAppVersion: "Version minimale de l'app",
    settingsRequirePhoto: 'Photo de profil obligatoire',
    settingsCoPresence: 'Co-présence récurrente',
    settingsCoPresenceHint:
      "Si deux profils se croisent souvent au même créneau horaire (filtres mutuels), chacun reçoit une alerte avec le profil de l'autre.",
    settingsCoPresenceEnabled: 'Alertes co-présence activées',
    settingsCoPresenceRadius: 'Distance max pour compter une co-présence (m)',
    settingsCoPresenceDays: 'Nombre de jours distincts (même heure) dans le mois',
    settingsPremium: 'Premium & lancement',
    settingsPremiumFreeForAll: 'Premium gratuit pour tous',
    settingsPremiumFreeForAllHint:
      'ON = toutes les options Premium actives pour chaque utilisateur (idéal au lancement). Défaut : ON.',
    settingsFeatures: 'Fonctionnalités',
    settingsLiveMap: 'Carte live',
    settingsChat: 'Messagerie',
    settingsCrushActions: 'Actions Crush / Hi',
    settingsCoPresenceApp: 'Alertes co-présence (app)',
    settingsSave: 'Enregistrer les paramètres',
    dashboardTitle: 'Tableau de bord',
    dashboardSubtitle: "Vue d'ensemble de l'application CrushShy",
    dashboardMaintenance: 'Maintenance active',
    statUsers: 'Utilisateurs',
    statActive: 'Actifs',
    statLive: 'En live',
    statOpenReports: 'Signalements ouverts',
    statIncomplete: 'Profils incomplets',
    statMatches: 'Matchs (total)',
    chartMatchesTitle: 'Matchs par utilisateur (aperçu)',
    recentActivity: 'Activité récente',
    seeAll: 'Voir tout →',
    quickUsers: 'Gérer les utilisateurs',
    quickReports: 'Modération & signalements',
    quickSettings: "Paramètres de l'app",
    statusActive: 'Actif',
    statusSuspended: 'Suspendu',
    statusBanned: 'Banni',
    usersTitle: 'Utilisateurs',
    usersSubtitle: 'Comptes, statuts et profils CrushShy',
    usersAdd: 'Ajouter',
    usersSearchPlaceholder: 'Rechercher nom, email, ID…',
    usersFilterAll: 'Tous les statuts',
    usersFilterActive: 'Actifs',
    usersFilterSuspended: 'Suspendus',
    usersFilterBanned: 'Bannis',
    usersFilterBtn: 'Filtrer',
    usersColUser: 'Utilisateur',
    usersColStatus: 'Statut',
    usersColLive: 'Live',
    usersColMatches: 'Matchs',
    usersColActions: 'Actions',
    usersLiveOn: '● Live',
    usersLiveOff: 'Hors ligne',
    usersDeleteAria: 'Supprimer',
    usersEmpty: 'Aucun utilisateur trouvé.',
    usersNewTitle: 'Nouvel utilisateur',
    usersDetailTitle: 'Détail',
    usersFirstName: 'Prénom',
    usersEmail: 'Email',
    usersAge: 'Âge',
    usersStatus: 'Statut',
    usersBio: 'Bio',
    usersLiveMode: 'Mode « Je suis là » (live)',
    usersProfileComplete: 'Profil complété',
    usersId: 'ID',
    usersLastActive: 'Dernière activité',
    usersReportsCount: 'Signalements',
    usersSave: 'Enregistrer',
    usersSelectHint: 'Sélectionne un utilisateur pour voir et modifier son profil.',
    usersDeleteConfirm: 'Supprimer cet utilisateur ?',
    reportsTitle: 'Signalements',
    reportsSubtitle: 'Modération et traitement des rapports utilisateurs',
    reportsFilterAll: 'Tous',
    reportsFilterOpen: 'Ouverts',
    reportsFilterReviewed: 'Traités',
    reportsFilterDismissed: 'Classés',
    reportsReportedBy: 'signalé par',
    reportsMarkReviewed: 'Marquer traité',
    reportsDismiss: 'Classer sans suite',
    reportsViewUsers: 'Voir utilisateurs',
    reportsEmpty: 'Aucun signalement pour ce filtre.',
    reasonHarassment: 'Harcèlement',
    reasonInappropriate: 'Contenu inapproprié',
    reasonSpam: 'Spam',
    reasonFake: 'Faux profil',
    reportStatusOpen: 'Ouvert',
    reportStatusReviewed: 'Traité',
    reportStatusDismissed: 'Classé sans suite',
    landingTitle: 'Rencontres à proximité, sans message à froid',
    landingLead:
      'Carte live, profils autour de toi, crush mutuel obligatoire avant d’échanger. Respect, 18+, modération des signalements.',
    landingBullet1: 'Mode live : vois qui est proche quand tu choisis d’être visible',
    landingBullet2: 'Crush réciproque = match, puis messages et icebreakers',
    landingBullet3: 'Pas de DM sans match — moins de harcèlement',
    landingDownload: 'Télécharge l’application',
    landingStore: 'Disponible sur l’App Store (iOS). Ouvre l’app et crée ton compte en quelques minutes.',
    landingPrivacy: 'Confidentialité',
    landingTerms: "Conditions d'utilisation",
    landingLoranrix: 'Site Loranrix',
    privacyTitle: 'Politique de confidentialité — CrushShy',
    privacyP1:
      'CrushShy collecte les données nécessaires au service : profil, position lorsque tu es en mode live, interactions (crush, matchs) et messages entre utilisateurs matchés.',
    privacyP2:
      "Tu peux exporter ou supprimer ton compte depuis l'application (Profil). Les signalements sont traités si nécessaire.",
    privacyP3: 'Contact : via le formulaire sur',
    termsTitle: "Conditions d'utilisation — CrushShy",
    termsP1:
      "L'application est réservée aux personnes majeures (18+). Le harcèlement, les contenus illicites et les faux profils peuvent entraîner une suspension.",
    termsP2:
      'Les messages ne sont possibles qu’après un crush mutuel. CrushShy peut faire évoluer le service et ces conditions.',
    termsP1Alt:
      'En utilisant CrushShy, tu acceptes un comportement respectueux. Le crush mutuel est requis avant l’envoi de messages. Les contenus inappropriés peuvent entraîner une suspension.',
    termsP2Alt: 'L’âge minimum est de 18 ans. Le service est fourni en l’état.',
    termsP3Alt:
      'L’abonnement mensuel « Premium » dans l’application mobile est facturé par Apple ou Google. Le prix et la durée sont indiqués avant achat. Le renouvellement est automatique sauf résiliation dans les réglages de votre compte boutique au moins 24 h avant la fin de la période. Utilisez « Restaurer les achats » si vous changez d’appareil. Les remboursements suivent les règles Apple ou Google.',
    privacyP4:
      'Si vous souscrivez à Premium dans l’application, le paiement est géré par Apple ou Google. Nous recevons uniquement les informations nécessaires pour activer votre abonnement. Nous ne stockons pas votre numéro de carte.',
    legalNavCrushShy: 'CrushShy',
    legalNavLoranrix: 'Loranrix',
    inviteHeading: 'Tu es invité(e) sur CrushShy',
    inviteCodeHint: 'Installe l’app, crée ton profil, puis entre ce code dans l’onglet parrainage si demandé.',
    inviteLearnMore: 'En savoir plus sur CrushShy →',
    inviteCodeSuffix: 'Code invitation : {code}.',
  },
  en: {
    langToggle: 'FR',
    navOverview: 'Overview',
    navUsers: 'Users',
    navReports: 'Reports',
    navSettings: 'Settings',
    toastLoadSettingsError: 'Failed to load settings',
    toastSettingsSaved: 'Settings saved',
    toastSaveError: 'Save failed',
    toastLoadDashboardError: 'Failed to load CrushShy',
    toastLoadUsersError: 'Failed to load users',
    toastLoadReportsError: 'Failed to load reports',
    toastUserCreated: 'User created',
    toastUserUpdated: 'User updated',
    toastUserDeleted: 'User deleted',
    toastDeleteError: 'Delete failed',
    toastReportUpdated: 'Report updated',
    toastError: 'Error',
    settingsTitle: 'Settings',
    settingsSubtitle: 'Global CrushShy app configuration',
    settingsMobileApp: 'Mobile app',
    settingsDemoUsers: 'Demo users (map & interactions)',
    settingsDemoUsersHint: 'OFF = hidden for all clients (current and future). Default: ON.',
    settingsAvailability: 'Availability',
    settingsMaintenance: 'Maintenance mode',
    settingsMaintenanceHint: 'Blocks app access for all users',
    settingsMaintenanceMessage: 'Maintenance message',
    settingsRules: 'Rules & limits',
    settingsMinAge: 'Minimum age',
    settingsMaxDistance: 'Default max distance (m)',
    settingsAutoSuspend: 'Auto-suspend after N reports',
    settingsMinAppVersion: 'Minimum app version',
    settingsRequirePhoto: 'Profile photo required',
    settingsCoPresence: 'Recurring co-presence',
    settingsCoPresenceHint:
      'When two profiles often cross paths at the same time slot (mutual filters), each gets an alert with the other profile.',
    settingsCoPresenceEnabled: 'Co-presence alerts enabled',
    settingsCoPresenceRadius: 'Max distance to count co-presence (m)',
    settingsCoPresenceDays: 'Distinct days (same hour) per month',
    settingsPremium: 'Premium & launch',
    settingsPremiumFreeForAll: 'Free Premium for everyone',
    settingsPremiumFreeForAllHint:
      'ON = all Premium features enabled for every user (ideal at launch). Default: ON.',
    settingsFeatures: 'Features',
    settingsLiveMap: 'Live map',
    settingsChat: 'Messaging',
    settingsCrushActions: 'Crush / Hi actions',
    settingsCoPresenceApp: 'Co-presence alerts (app)',
    settingsSave: 'Save settings',
    dashboardTitle: 'Dashboard',
    dashboardSubtitle: 'CrushShy app overview',
    dashboardMaintenance: 'Maintenance on',
    statUsers: 'Users',
    statActive: 'Active',
    statLive: 'Live',
    statOpenReports: 'Open reports',
    statIncomplete: 'Incomplete profiles',
    statMatches: 'Matches (total)',
    chartMatchesTitle: 'Matches per user (preview)',
    recentActivity: 'Recent activity',
    seeAll: 'See all →',
    quickUsers: 'Manage users',
    quickReports: 'Moderation & reports',
    quickSettings: 'App settings',
    statusActive: 'Active',
    statusSuspended: 'Suspended',
    statusBanned: 'Banned',
    usersTitle: 'Users',
    usersSubtitle: 'CrushShy accounts, statuses and profiles',
    usersAdd: 'Add',
    usersSearchPlaceholder: 'Search name, email, ID…',
    usersFilterAll: 'All statuses',
    usersFilterActive: 'Active',
    usersFilterSuspended: 'Suspended',
    usersFilterBanned: 'Banned',
    usersFilterBtn: 'Filter',
    usersColUser: 'User',
    usersColStatus: 'Status',
    usersColLive: 'Live',
    usersColMatches: 'Matches',
    usersColActions: 'Actions',
    usersLiveOn: '● Live',
    usersLiveOff: 'Offline',
    usersDeleteAria: 'Delete',
    usersEmpty: 'No users found.',
    usersNewTitle: 'New user',
    usersDetailTitle: 'Details',
    usersFirstName: 'First name',
    usersEmail: 'Email',
    usersAge: 'Age',
    usersStatus: 'Status',
    usersBio: 'Bio',
    usersLiveMode: '“I’m here” mode (live)',
    usersProfileComplete: 'Profile complete',
    usersId: 'ID',
    usersLastActive: 'Last active',
    usersReportsCount: 'Reports',
    usersSave: 'Save',
    usersSelectHint: 'Select a user to view and edit their profile.',
    usersDeleteConfirm: 'Delete this user?',
    reportsTitle: 'Reports',
    reportsSubtitle: 'User report moderation',
    reportsFilterAll: 'All',
    reportsFilterOpen: 'Open',
    reportsFilterReviewed: 'Reviewed',
    reportsFilterDismissed: 'Dismissed',
    reportsReportedBy: 'reported by',
    reportsMarkReviewed: 'Mark reviewed',
    reportsDismiss: 'Dismiss',
    reportsViewUsers: 'View users',
    reportsEmpty: 'No reports for this filter.',
    reasonHarassment: 'Harassment',
    reasonInappropriate: 'Inappropriate content',
    reasonSpam: 'Spam',
    reasonFake: 'Fake profile',
    reportStatusOpen: 'Open',
    reportStatusReviewed: 'Reviewed',
    reportStatusDismissed: 'Dismissed',
    landingTitle: 'Nearby dating, no cold DMs',
    landingLead:
      'Live map, people around you, mutual crush required before chatting. Respect, 18+, moderated reports.',
    landingBullet1: 'Live mode: see who’s nearby when you choose to be visible',
    landingBullet2: 'Mutual crush = match, then messages and icebreakers',
    landingBullet3: 'No DMs without a match — less harassment',
    landingDownload: 'Download the app',
    landingStore: 'Available on the App Store (iOS). Open the app and sign up in minutes.',
    landingPrivacy: 'Privacy',
    landingTerms: 'Terms of use',
    landingLoranrix: 'Loranrix site',
    privacyTitle: 'Privacy policy — CrushShy',
    privacyP1:
      'CrushShy collects data needed for the service: profile, location when you are in live mode, interactions (crushes, matches) and messages between matched users.',
    privacyP2:
      'You can export or delete your account from the app (Profile). Reports are handled when needed.',
    privacyP3: 'Contact: via the form at',
    termsTitle: 'Terms of use — CrushShy',
    termsP1:
      'The app is for adults only (18+). Harassment, illegal content and fake profiles may lead to suspension.',
    termsP2:
      'Messages are only possible after a mutual crush. CrushShy may update the service and these terms.',
    termsP1Alt:
      'By using CrushShy you agree to respectful behavior. A mutual crush is required before messaging. Inappropriate content may lead to suspension.',
    termsP2Alt: 'Minimum age is 18. The service is provided as-is.',
    termsP3Alt:
      'The monthly “Premium” subscription in the mobile app is billed by Apple or Google. Price and duration are shown before purchase. Renewal is automatic unless you cancel in your store account settings at least 24 hours before the period ends. Use “Restore purchases” when changing devices. Refunds follow Apple or Google rules.',
    privacyP4:
      'If you subscribe to Premium in the app, payment is handled by Apple or Google. We only receive the information needed to activate your subscription. We do not store your card number.',
    legalNavCrushShy: 'CrushShy',
    legalNavLoranrix: 'Loranrix',
    inviteHeading: 'You’re invited to CrushShy',
    inviteCodeHint: 'Install the app, create your profile, then enter this code in the referral section if asked.',
    inviteLearnMore: 'Learn more about CrushShy →',
    inviteCodeSuffix: 'Invite code: {code}.',
  },
};

export function crushshyT(lang, key, vars = {}) {
  const table = messages[lang] || messages.fr;
  let text = table[key] ?? messages.fr[key] ?? key;
  Object.entries(vars).forEach(([k, v]) => {
    text = text.replaceAll(`{${k}}`, String(v));
  });
  return text;
}

export function useCrushShyT() {
  const { language } = useLanguage();
  return useCallback((key, vars) => crushshyT(language, key, vars), [language]);
}

export function crushshyLocale(language) {
  return language === 'en' ? 'en-US' : 'fr-FR';
}
